import { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';
import { DEBOUNCE_DELAYS } from '@constants/debounceDelays';
import { Check, Times } from '@assets/svgs';

export const PasswordHelperGuide = ({
  regex,
  isDirty,
  text,
  value,
  onChange,
}: {
  isDirty: boolean;
  regex?: RegExp;
  onChange?: (value: string) => boolean;
  text: string;
  value: string;
}) => {
  const [showError, setShowError] = useState(isDirty);

  const handleDebouncedError = useDebouncedCallback(() => {
    setShowError(true);
  }, DEBOUNCE_DELAYS.TYPING);

  let valid = regex ? regex.test(value) : true;

  if (onChange) {
    valid = onChange(value);
  }

  const invalid = !valid && value.length > 0;
  if (valid) {
    handleDebouncedError.cancel();
  }

  if (invalid) {
    handleDebouncedError();
  }

  const color = valid ? 'text.main' : showError ? 'error.main' : 'text.main';

  return (
    <Grid
      data-testid='password-helper-guide'
      key={text}
      sx={{
        display: 'flex',
        alignItems: 'baseline',
        transitionDuration: '.3s',
        color,
      }}
    >
      <Grid
        sx={{
          mr: 0.5,
          width: 10,
          transform: 'translateY(1px)',
        }}
      >
        {valid ? (
          <Check data-testid='check-icon' width='10px' height='10px' />
        ) : showError ? (
          <Times data-testid='times-icon' width='10px' height='10px' />
        ) : (
          <Box>•</Box>
        )}
      </Grid>
      <Typography
        variant='caption'
        sx={{
          color,
        }}
      >
        {text}
      </Typography>
    </Grid>
  );
};
